var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "row",
      class: { selected: _vm.added, [_vm.$style.row]: true },
    },
    [
      _c("check-box", {
        staticClass: "cell checkboxCell dark-icon",
        attrs: { value: _vm.added, "check-box-value": true },
        on: { input: _vm.toggle },
      }),
      _vm._l(_vm.columns, function (column) {
        return _c(
          "div",
          {
            key: column,
            staticClass: "cell",
            class: {
              [_vm.$style[column]]: _vm.$style[column],
              [_vm.$style.cell]: true,
            },
          },
          [
            _vm.is(column, "category")
              ? [
                  _c("column-select", {
                    attrs: {
                      icon: "face",
                      label: "Select category",
                      value: _vm.row.directoryViewId,
                      text: _vm.getViewName() || "___",
                      options: _vm.views,
                    },
                    on: { input: _vm.assignView },
                  }),
                ]
              : _vm.is(column, "type")
              ? _c("div", [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.row.type === "ACTIVE"
                          ? "Power User"
                          : "Passive User"
                      )
                    ),
                  ]),
                ])
              : _c(
                  "div",
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.getColumnValue(column) || "___")),
                    ]),
                    _vm.is(column, "name") && _vm.row.type === "ACTIVE"
                      ? [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("offline_bolt"),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "rbTooltip simple",
                              attrs: { tooltip: "placement:top-start" },
                            },
                            [
                              _vm._v(
                                " A power user can make hotel recommendations "
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
          ],
          2
        )
      }),
      _c(
        "div",
        {
          staticClass: "cell cell-xs",
          staticStyle: { "min-width": "50px", "max-width": "50px" },
        },
        [
          _c("div", { class: _vm.$style.actions }, [
            !_vm.row.directoryViewId
              ? _c(
                  "i",
                  {
                    staticClass: "material-icons",
                    class: _vm.$style.clickable,
                    on: { click: _vm.drop },
                  },
                  [_vm._v(" delete ")]
                )
              : _c(
                  "i",
                  {
                    staticClass: "material-icons",
                    class: _vm.$style.clickable,
                    on: { click: _vm.link },
                  },
                  [_vm._v(" visibility ")]
                ),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }